import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { isMyLoanInfoWindow } from './core/models/myloaninfo-window';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(err: unknown): void {
    if (isMyLoanInfoWindow(window)) {
      Sentry.captureException(err);
    }
    console.error(err);
  }
}
